export default "__VITE_ASSET__6d65a74c__"